import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FaPlane } from "react-icons/fa";
import "./FlightLogoLoader.css";

const FlightLogoLoader = ({
  logoSrc,
  logoAlt = "Hotels River Logo",
  brandTextFallback = "HOTELS RIVER",
  caption = "טוענים תוצאות",
  showCaption = true,
  compact = false,
  className,
}) => {
  return (
    <div
      className={classNames("flight-logo-loader", className, {
        "flight-logo-loader--compact": compact,
      })}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="flight-logo-loader__brand">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={logoAlt}
            className="flight-logo-loader__brand-logo"
            width={220}
            height={55}
            decoding="async"
          />
        ) : brandTextFallback ? (
          <div className="flight-logo-loader__brand-text">{brandTextFallback}</div>
        ) : null}
      </div>

      <div className="flight-logo-loader__runway" aria-hidden="true">
        <div className="flight-logo-loader__trail" />
        <FaPlane className="flight-logo-loader__plane" />
      </div>

      {showCaption && (
        <p className="flight-logo-loader__caption">
          {caption}
          <span className="flight-logo-loader__caption-dots" aria-hidden="true">
            <span className="flight-logo-loader__caption-dot">.</span>
            <span className="flight-logo-loader__caption-dot">.</span>
            <span className="flight-logo-loader__caption-dot">.</span>
          </span>
        </p>
      )}
    </div>
  );
};

FlightLogoLoader.propTypes = {
  logoSrc: PropTypes.string,
  logoAlt: PropTypes.string,
  brandTextFallback: PropTypes.string,
  caption: PropTypes.string,
  showCaption: PropTypes.bool,
  compact: PropTypes.bool,
  className: PropTypes.string,
};

export default FlightLogoLoader;
